import React from 'react';
import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { LocalizedLink, useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { IGamesSectionHeaderProps } from './types';

import styles from './index.module.css';

const GamesSectionHeader: React.FC<IGamesSectionHeaderProps> = ({
  title,
  viewAll,
  onViewAllClick,
  className,
  classNames = {}
}) => {
  const { t } = useI18n();

  const {
    searchGameSectionTitle = '',
    searchGameSectionTitleWrapper = '',
    realTimeWinsTitleWrapper = ''
  } = classNames;

  return (
    <Box
      className={clsx([
        styles.wrapper,
        searchGameSectionTitleWrapper,
        realTimeWinsTitleWrapper,
        className
      ])}
      align="center"
      justify="between"
    >
      {title && (
        <AText
          breed="BU"
          color="txt_color_3"
          size="2xl"
          className={clsx(
            styles.title,
            classNames?.title,
            searchGameSectionTitle
          )}
        >
          {t(title)}
        </AText>
      )}
      {viewAll && (
        <LocalizedLink
          to={viewAll}
          className={styles.link}
          onClick={onViewAllClick}
        >
          <Box align="center" right="m">
            <AText breed="BU" size="m" color="btn_quaternary_color_2">
              {t('header.announcements.view.all')}
            </AText>
            <Icon
              size="s"
              name="icons/general/nav/go-to"
              color="btn_quaternary_color_2"
              className={styles.icon}
            />
          </Box>
        </LocalizedLink>
      )}
    </Box>
  );
};

export default GamesSectionHeader;
